export const roleCreatecolumns = [
    { Header: 'Id', accessor: 'id'},
    { Header: 'Role Name', accessor: 'roleName' },
    { Header: 'Description', accessor: 'description' },
    { Header: 'Action', accessor: 'action' },
  ];

export const roleCreateTableData = [
    {
        id: '1',
        roleName: 'Booking',
        description: 'Booking All Permission',
    },
    {
        id: '2',
        roleName: 'Moderator',
        description: 'New Role Permission',
    },
    {
        id: '3',
        roleName: 'Manager',
        description: 'Manager Role List',
    },
    {
        id: '4',
        roleName: 'Administrator',
        description: 'Administrator Role with All Permissions',
    },
    {
        id: '5',
        roleName: 'Customer Service',
        description: 'Customer Service Role with Limited Permissions',
    },
    {
        id: '6',
        roleName: 'Accountant',
        description: 'Accountant Role for Financial Operations',
    },
    {
        id: '7',
        roleName: 'Human Resources',
        description: 'Human Resources Role for HR Management',
    },
    {
        id: '8',
        roleName: 'Sales Representative',
        description: 'Sales Representative Role for Sales Operations',
    },
    {
        id: '9',
        roleName: 'Marketing Manager',
        description: 'Marketing Manager Role for Marketing Activities',
    },
    {
        id: '10',
        roleName: 'Manager',
        description: 'Manager Role List',
    },
]